var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3615 8H9.91175H5.90479C5.21911 8 4.87627 8.75891 5.36196 9.20379L9.06179 12.5927C9.65462 13.1358 10.6189 13.1358 11.2117 12.5927L12.6188 11.3039L14.9115 9.20379C15.3901 8.75891 15.0472 8 14.3615 8Z",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.87aaedee72c39ed6a98eb4f6ee18c4b1.svg";
export { ForwardRef as ReactComponent };